<template>
  <v-row v-if="shouldShowMultipleOptions">
    <v-col cols="12" class="pa-4 pb-0">
      <v-btn
        outlined
        v-for="(option, optionIndex) in filteredOptions"
        :key="optionIndex"
        class="rounded-xl mr-2"
        size="x-small"
        :color="option.isSelected ? 'primary' : '#757575'"
        style="font-size: 10px"
        @click="selectOption(optionIndex, option)"
      >
        <span style="font-size: 10px" class="truncate pt-3">
          <template v-if="field.type === FieldType.Numeric">
            {{ Utils.number.toUserFormat(option.valueNum, userDecSep, userThouSep) }}
          </template>
          <template v-else-if="field.type === FieldType.DateTime">
            {{ Utils.date.toUserFormat(new Date(option.valueDate), userDateFormat) }}
          </template>
          <template v-else>
            {{ option.valueStr }}
          </template>
          <small class="grey--text caption pb-1 d-block ">
            {{ $t('DocIntelligenceProvider_' + option.providerId) }}
          </small>
        </span>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import FieldType from '@/ecm/variables/FieldType';
import Utils from '@/ecm/common/Utils';

export default {
    name: 'DocumentPendingReviewOptionsValue',
    props: {
        field: {
            type: Object,
        },
        index: {
            type: Number,
        }
    },
    computed: {
        filteredOptions() {
            if (this.field && Array.isArray(this.field.optionsValue)) {
                return this.field.optionsValue.filter(option => !option.isUserAdded);
            }
            return [];
        },
        shouldShowMultipleOptions() {
            return (
                Array.isArray(this.field.optionsValue) &&
                this.field.optionsValue.length > 1
            );
        },
    },
    data() {
        return {
            FieldType,
            Utils,
            userDecSep: this.$store.getters['account/user'].MetricDecimalSep,
            userThouSep: this.$store.getters['account/user'].MetricThousandSep,
            userDateFormat: this.$store.getters['account/user'].MetricDateFormat,
        };
    },
    methods: {
        selectOption(optionIndex, option) {
            this.field.optionsValue.forEach(result => (result.isSelected = false));
            this.field.optionsValue[optionIndex].isSelected = true;

            // Emit event or call method when option is selected
            this.$emit('option-selected', option, this.field);
        },
    }
};
</script>

<style scoped>
.v-card .caption {
  font-size: 8px !important;
}
</style>
